import React, { useState, useMemo } from "react";
import { Select } from "antd";
import { continents, countries } from "countries-list";

let countryNameCodeMap = {};
Object.keys(countries).forEach((key) => {
  countryNameCodeMap[key] = countries[key].name;
});

const ClubGroupFilter = ({
  childGroupDetails = [],
  childrenGroupIds = [],
  onChange,
}) => {
  const [filterType, setFilterType] = useState("all");
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);

  // Get unique regions from child groups
  const regionOptions = useMemo(() => {
    const uniqueRegions = Array.from(
      new Set(childGroupDetails.map((g) => g.supportersRegion).filter(Boolean))
    );
    return uniqueRegions.map((code) => ({
      label: continents[code] || code,
      value: code,
    }));
  }, [childGroupDetails]);

  // Get unique countries from child groups
  const countryOptions = useMemo(() => {
    const uniqueCountries = Array.from(
      new Set(childGroupDetails.map((g) => g.supportersCountry).filter(Boolean))
    );
    return uniqueCountries.map((code) => ({
      label: countryNameCodeMap[code] || code,
      value: code,
    }));
  }, [childGroupDetails]);

  // Group options
  const groupOptions = useMemo(() => {
    return childGroupDetails.map((group) => ({
      label: group.groupName,
      value: group.id,
    }));
  }, [childGroupDetails]);

  // Handle filter type change
  const handleFilterTypeChange = (value) => {
    setFilterType(value);
    setSelectedRegion(null);
    setSelectedGroup(null);

    if (value === "all") {
      onChange?.(childrenGroupIds);
    } else if (value === "official") {
      const officialGroupIds = childGroupDetails
        .filter((g) => g.groupType === "Official Supporters Group")
        .map((g) => g.id);
      onChange?.(officialGroupIds);
    }
  };

  // Handle region selection
  const handleRegionChange = (value) => {
    setSelectedRegion(value);
    if (value) {
      const groupIds = childGroupDetails
        .filter(
          (g) => g.supportersRegion === value || g.supportersCountry === value
        )
        .map((g) => g.id);
      onChange?.(groupIds);
    }
  };

  // Handle group selection
  const handleGroupChange = (value) => {
    setSelectedGroup(value);
    if (value) {
      onChange?.([value]);
    }
  };

  return (
    <div style={{ display: "flex", gap: "12px", flex: 1 }}>
      {/* Filter Type Dropdown */}
      <Select
        style={{ width: 200 }}
        value={filterType}
        onChange={handleFilterTypeChange}
        options={[
          { label: "All Groups", value: "all" },
          { label: "Official Groups", value: "official" },
          { label: "By Region/Country", value: "region" },
          { label: "By Group", value: "group" },
        ]}
      />

      {/* Region/Country Dropdown - shows when "region" is selected */}
      {filterType === "region" && (
        <Select
          style={{ width: 250 }}
          placeholder="Select region or country"
          value={selectedRegion}
          onChange={handleRegionChange}
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={[
            {
              label: "Regions",
              options: regionOptions,
            },
            {
              label: "Countries",
              options: countryOptions,
            },
          ]}
        />
      )}

      {/* Group Dropdown - shows when "group" is selected */}
      {filterType === "group" && (
        <Select
          style={{ width: 250 }}
          placeholder="Select a group"
          value={selectedGroup}
          onChange={handleGroupChange}
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={groupOptions}
        />
      )}
    </div>
  );
};

export default ClubGroupFilter;
